import { call, put, select } from 'redux-saga/effects';
import { getProductAfterSaleActions as getProductAfterSaleActionsAda } from '@bitComponents/adabyron/cqv2';
import { WEB_SERVICES } from './webServices';

const contextStore = state => state.context.data;

export function* getProductAfterSaleActions(params) {
  const {
    productId,
    reduxUpdate,
    normalizeHttpErrors,
  } = params;
  try {
    const context = yield select(contextStore);
    const response = yield call(getProductAfterSaleActionsAda, { productId }, context);
    
    return response;
  } catch (error) {
    const { errorUpdate } = reduxUpdate;
    const errorNormalized = yield call(normalizeHttpErrors, WEB_SERVICES.GET_CUSTOMER_PRODUCTS_TO_HIRE_PRODUCT_OFFERING, error);
    if (errorUpdate) {
      yield put(errorUpdate(errorNormalized));
    }

    throw error;
  }
}
